import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { catchError, tap } from "rxjs";
import { ApiService } from "../api/api.service";
import { AuthService } from "./services/auth.service";
import { inject } from "@angular/core";
import { StrapiService } from "../api/strapi.service";


const handlerResolverError = (route: Router) => async (error: any) => {
  await route.navigate(['/404']);
  throw error;
};

export const subscribedWallets = () => {
  const router: Router = inject(Router);
  return inject(ApiService).getSubscribedWallets().pipe(catchError(handlerResolverError(router)));
};

export const getOperations = () => {
  const router: Router = inject(Router);
  return inject(ApiService).getOperations().pipe(catchError(handlerResolverError(router)));
};

export const getInvoices = () => {
  const router: Router = inject(Router);
  return inject(ApiService).getInvoices().pipe(catchError(handlerResolverError(router)));
};

export const getTableSettings = <T>(tableName: string) => () => {
  const authService: AuthService = inject(AuthService);
  const apiService = inject(ApiService);
  const user = authService.accountDto();
  if (!user) return;
  const { uuid } = user;
  return apiService.getTableSettingsByUserIdAndTableName<T>(uuid, tableName);
}

export const getEmailCodeResponse = (activatedRouteSnapshot: ActivatedRouteSnapshot) => {
  const inviteCode = activatedRouteSnapshot.queryParamMap.get('inviteCode');
  const router = inject(Router);
  if (!inviteCode) return null;
  return inject(ApiService).getEmailCodeResponse(inviteCode).pipe(tap(async ({ isUsed }) => {
    // Если inviteCode уже использован, то перенаправляем на главную
    if (isUsed) {
      await router.navigate(['/']);
    }
  }), catchError(handlerResolverError(router)));
};

export const getPrivacyPolicy = () => {
  const router: Router = inject(Router);
  return inject(StrapiService).getPrivacyPolicy().pipe(catchError(handlerResolverError(router)));
};

export const getTermsOfUse = () => {
  const router: Router = inject(Router);
  return inject(StrapiService).getTermsOfUse().pipe(catchError(handlerResolverError(router)));
};
